import { useApiQuery } from 'hooks/useApiQuery'

export const useGetSweepstakeByIdWithDrawingInfo = ({
  sweepstakeId,
  corporateAccountId,
}: {
  sweepstakeId?: number
  corporateAccountId?: number
}) =>
  useApiQuery({
    path: '/le-connect/contests/{id}/drawing-info/{corporateAccountId}',
    method: 'get',
    queryKey: ['/sweepstakes/drawing-info', sweepstakeId, corporateAccountId],
    queryArgs: { id: sweepstakeId, corporateAccountId },
    enabled: sweepstakeId != null && corporateAccountId != null,
  })
